import React from "react";

export default function TermsOfRelease() {
  return (
    <div className="p-3 md:p-6 w-full h-full">
      <h3>Terms of Release</h3>
      <div>This page is unavailable at the moment.</div>
    </div>
  );
}
